

// Libs
import {onMounted, reactive, ref} from 'vue';
import router from '@/router';

// Providers
import { createUserProviderState } from '@/store/modules/user/UserProvider';
import { PsValueProvider } from '@/store/modules/core/PsValueProvider';
import { createUserStateListProviderState } from '@/store/modules/user/UserStateProvider';

// Components
import PsContentContainer from '@/components/layouts/container/PsContentContainer.vue';
import PsLabelHeader4 from '@/components/core/label/PsLabelHeader4.vue';
import PsButton from '@/components/core/buttons/PsButton.vue';
import PsIcon from '@/components/core/icons/PsIcon.vue';
import PsInput from '@/components/core/input/PsInput.vue';
import PsTextarea from '@/components/core/textarea/PsTextarea.vue';
import PsCheckboxValue from '@/components/core/checkbox/PsCheckboxValue.vue';
import ProfileUpdateViewHolder from '@/object/holder/ProfileUpdateViewHolder';
import PsStatus from '@/api/common/PsStatus';
import PsLoadingDialog from '@/components/core/dialog/PsLoadingDialog.vue';
import PsErrorDialog from '@/components/core/dialog/PsErrorDialog.vue';
import UserPhoneLoginVerificationModal from '@/components/modules/user/UserPhoneLoginVerificationModal.vue';
import PsLabel from '@/components/core/label/PsLabel.vue';
import PsLabelTitle3 from '@/components/core/label/PsLabelTitle3.vue';
import PsRouteLink from '@/components/core/link/PsRouteLink.vue';
import firebaseApp from 'firebase/app';
import "firebase/auth";

// language
import { i18n } from '@/assets/locales/index';
import PsUtils from '@/utils/PsUtils';
import PsConst from '@/object/constant/ps_constants';

export default {
    name : "EditProfileView",
    components : {
        PsContentContainer,
        PsButton,
        PsLabelHeader4,
        PsIcon,
        PsInput,
        PsTextarea,
        PsCheckboxValue,
        PsLabelTitle3,
        PsLoadingDialog,
        PsErrorDialog,
        UserPhoneLoginVerificationModal,
        PsLabel,
        PsRouteLink
    },
    setup() {
  
        // Providers
        const userProvider = createUserProviderState();
        const userStateListProvider = createUserStateListProviderState();

        // Init Variables
        const valueHolder = PsValueProvider.psValueHolder;
        const loginUserId = valueHolder.getLoginUserId();
       
        if(loginUserId == null || loginUserId == '' || loginUserId == PsConst.NO_LOGIN_USER) {
            router.push({ name : "login"});
        }

        const previewImage = reactive({
            data : [] as any
        });
        let selectedFile;
        const holder = reactive(new ProfileUpdateViewHolder());
        const date_picker = ref();
        
        
        const date = new Date();
        date.setFullYear(date.getFullYear() - 18);
        const pickedDate = ref();
        const upperDate = ref(date);
        const image = ref();
        const profilePhoto = ref('');
        const ps_loading_dialog = ref();
        const ps_error_dialog = ref();
        const user_phone_login_verification_modal = ref();
        const isValidUserName = ref(false);
        const isValidPhone = ref(false);
        const isValidPhoneFormat = ref(false);
        const isValidWhatsapp = ref(false);
        const isValidWhatsappFormat = ref(false);
        let oldUser;
        
        // Functions
        onMounted(() => {
            loadUserData();
            loadAppVerifier();
        });

        async function loadUserData() {
            ps_loading_dialog.value.openModal();
            const returnData = await userProvider.getUser(loginUserId);
           
            oldUser = returnData.data[0];
            ps_loading_dialog.value.closeModal();
            if(returnData.status == PsStatus.SUCCESS) {
                const userInfo = returnData.data[0];
                holder.userId = userInfo.userId;
                holder.userName = userInfo.userName;
                holder.userEmail = userInfo.userEmail;
                holder.userPhone = userInfo.userPhone;
                holder.whatsapp = userInfo.whatsapp;
                holder.city = userInfo.city;
                holder.userAboutMe = userInfo.userAboutMe;
                holder.userAddress = userInfo.userAddress;

                holder.isShowEmail = userInfo.isShowEmail;
                holder.isShowEmailBool = holder.isShowEmail == '1';
                holder.isShowPhone = userInfo.isShowPhone;
                holder.isShowPhoneBool = holder.isShowPhone == '1';
                holder.userType = userInfo.userType;
                holder.planExpiryDate = userInfo.planExpiryDate;
     
                profilePhoto.value = userInfo.userProfilePhoto.toString();
                
            } else {
                ps_error_dialog.value.openModal('', returnData.message);
                router.push({ name : "dashboard"});
            }
        }

        function validateName(evt) {
            evt = (evt) ? evt : window.event;
            const charCode = (evt.which) ? evt.which : evt.keyCode;
           
            if ( charCode < 42 || charCode > 57 ) {
                evt.preventDefault();
            } else {
                return true;
            }

            const pattern = /^\/$|(\/[a-zA-Z_0-9-]+)+$/;
            const res = pattern.test(evt.target.value);
            if (!res) {
                isValidUserName.value = false;
            } else {
                isValidUserName.value = true;
            }
        }

        function phoneNumber(evt) {
            evt = (evt) ? evt : window.event;
            const charCode = (evt.which) ? evt.which : evt.keyCode;
           
            if ( charCode < 42 || charCode > 57 ) {
                evt.preventDefault();
            } else {
               console.log(evt.target.value.length);
                if(evt.target.value.length == 9){
                    isValidPhoneFormat.value = false;
                } else {
                    isValidPhoneFormat.value = true;
                }

                const pattern = /^\/$|(\/[a-zA-Z_0-9-]+)+$/;
                const res = pattern.test(evt.target.value);
                if (!res) {
                    isValidPhone.value = false;
                } else {
                    isValidPhone.value = true;
                }
                return true;
            }
        }
        
        function whatsapp(evt) {
            evt = (evt) ? evt : window.event;
            const charCode = (evt.which) ? evt.which : evt.keyCode;
           
            if ( charCode < 42 || charCode > 57 ) {
                evt.preventDefault();
            } else {

                if(evt.target.value.length == 9){
                     isValidPhoneFormat.value = false;
                } else {
                    isValidPhoneFormat.value = true;
                }

                const pattern = /^\/$|(\/[a-zA-Z_0-9-]+)+$/;
                const res = pattern.test(evt.target.value);
                if (!res) {
                    isValidPhone.value = false;
                } else {
                    isValidPhone.value = true;
                }

                return true;
            }

        }

        function isNumber(evt) {
            evt = (evt) ? evt : window.event;
            const charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 ) {
                evt.preventDefault();
            } else {
                return true;
            }
        }

        function onImageSelected(event) {
            const selectedFiles = event.target.files;

            if(selectedFiles && selectedFiles.length > 1) {
                window.alert("Over 5");
            }else {
                previewImage.data = [];
                for(let i=0; i<selectedFiles.length; i++) {
                    const reader = new FileReader
                    reader.onload = e => {
                        (previewImage.data as string[]).push(e.target ? e.target.result ? e.target.result.toString() : '' : '')
                    }
                    reader.readAsDataURL(selectedFiles[i]) 
                    selectedFile = selectedFiles[i];                       
                }                
            }
        }

        function onImageClick() {
            image.value.click();

        }

        function uploadImage() {
            userProvider.postImageUpload(valueHolder.getLoginUserId(), "web", selectedFile, '');
        }


        async function submit() {
            
             let errorStatus = true;
            if (holder.userName == '' || holder.userName == undefined) {
                isValidUserName.value = true;
                errorStatus = false;
            }
            if (holder.userPhone == '' || holder.userPhone == undefined) {
                isValidPhone.value = true;
                errorStatus = false;
            }
            if (holder.userPhone.length !=  10 ) {
                isValidPhoneFormat.value = true;
                errorStatus = false;
            }
            if (holder.whatsapp == '' || holder.whatsapp == undefined) {
                isValidWhatsapp.value = true;
                errorStatus = false;
            }
            if (holder.whatsapp.length !=  10 ) {
                isValidWhatsappFormat.value = true;
                errorStatus = false;
            }
            if(!errorStatus) {
                window.scrollTo(0, 0);
                return;
            }
            holder.isShowEmail = holder.isShowEmailBool ? '1' : '0';
            holder.isShowPhone = holder.isShowPhoneBool ? '1' : '0';
 
            ps_loading_dialog.value.openModal();
            ps_loading_dialog.value.setMessage(i18n.global.t('edit_profile__updating_profile'));
            const returnData = await userProvider.postProfileUpdate(holder);
               
            if(selectedFile != undefined){
              
                ps_loading_dialog.value.setMessage(i18n.global.t('edit_profile__uploading_profile_image'));
                await userProvider.postImageUpload(valueHolder.getLoginUserId(), "web", selectedFile, '');
            } 
            ps_loading_dialog.value.closeModal();
          
            if(returnData.status == PsStatus.SUCCESS) {
                ps_error_dialog.value.openModal(
                    i18n.global.t('edit_profile__success'),
                    i18n.global.t('edit_profile__profile_updated'));
            }else if(returnData.status == PsStatus.ERROR ){
                    ps_error_dialog.value.openModal('', returnData.message);
            }
            

        }

        async function loadStateList() {
            await userStateListProvider.loadUserStateList();            
        }

    
        function isPhoneVerified(){
            if(holder.userPhone ==  oldUser.userPhone){
                submit();
            }else{
                phoneVerificatrion(holder.userPhone);
                
            }
        }
        let appVerifier;
        function loadAppVerifier()  {
            // Init recaptchaVerifier
            ps_loading_dialog.value.openModal();
            setTimeout(()=>{
                // window.recaptchaVerifier.clear();
                (window as any).recaptchaVerifier = new firebaseApp.auth.RecaptchaVerifier('recaptcha-container', {
                    'size': 'invisible',
                    'callback': (response) => {
                        PsUtils.log("Callback");
                        PsUtils.log(response);
                    },
                    'expired-callback': () => {
                        PsUtils.log("expiry callback")
                    }
                });
                
                appVerifier =  (window as any).recaptchaVerifier;
                ps_loading_dialog.value.closeModal();
            },1000);
        }

        async function phoneVerificatrion(phone) {
            
            ps_loading_dialog.value.openModal();
            const verifier = appVerifier;
            console.log(phone+verifier);
            // const confirmationResult = await firebaseApp.auth().signInWithPhoneNumber("+91"+phone, verifier).catch((error) => {
            //     ps_loading_dialog.value.closeModal();
               
            //     ps_error_dialog.value.openModal(
            //         i18n.global.t('edit_profile__error_in_changing_phone_number'), error?.message);
                
            // });
            const responseData = await userProvider.userSentPhoneVerification( holder.userPhone, holder.userName, holder.userPhone); 
            if(responseData.status == 1) { 
            ps_loading_dialog.value.closeModal();

            // if(confirmationResult != undefined) {
                user_phone_login_verification_modal.value.openModal(
                    'Whatsapp No Verification', 
                    '', 
                    'Submit', 
                    'Cancel', 
                    async (code) => {
                        
                        ps_loading_dialog.value.openModal();
                        // confirmationResult.confirm(code).then(async (userCredential) => {
                            
                        //     if(userCredential != null
                        //         && userCredential.user != null
                        //         && userCredential.user.uid != null 
                        //         && userCredential.user.uid != '' ) {
                            const responseData = await userProvider.userVerifyPhoneVerification( holder.userPhone, holder.userName, holder.userPhone, code); 
                            console.log(responseData);
                            console.log(userProvider.userResource);
                            if(responseData.status == 1) { 
                                // call backend server
                                ps_loading_dialog.value.closeModal();
                                submit();
                            }else {
                                PsUtils.log("ERROR");

                            }
                        }).catch((error) => {
                            // User couldn't sign in (bad verification code?)
                            ps_loading_dialog.value.closeModal();
                            ps_error_dialog.value.openModal(i18n.global.t('edit_profile__error_in_changing_phone_number'), error?.message);   
                        });   

                }else{
                    PsUtils.log("Cancel");
                }
        }
        
        return {
            userStateListProvider,
            previewImage,
            onImageSelected,
            uploadImage,
            userProvider,
            submit,
            holder,
            date_picker,
            pickedDate,
            loadStateList,
            image,
            onImageClick,
            profilePhoto,
            ps_loading_dialog,
            ps_error_dialog,
            upperDate,
            phoneNumber,
            whatsapp,
            validateName,
            isNumber,
            user_phone_login_verification_modal,
            isPhoneVerified,
            isValidUserName,
            isValidPhone,
            isValidPhoneFormat,
            isValidWhatsapp,
            isValidWhatsappFormat
        }
    }
}
